"use client";

import { useSnackbarHandler } from "@repo/lib/hooks/common";
import { addToWishlist, removeFromWishlist } from "@repo/server-actions/wishlist";
import { IconWishlist, IconWishlistFilled } from "@repo/assets/images";
import { useAddToWishlistEvent, useRemoveFromWishlistEvent } from "@repo/lib/hooks/gtm";
import { useTrackAddToWishlist, useTrackRemoveFromWishlist } from "@repo/lib/hooks/webengage";
import { LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useLocale } from "next-intl";
import { useCallback, useMemo, useTransition } from "react";
const ToggleWishlistButton = props => {
  const {
    productId,
    variant,
    items,
    isPdp,
    product,
    session
  } = props;
  const [isPending, startTransition] = useTransition();
  const locale = useLocale();
  const {
    handleAddToWishlistEvent
  } = useAddToWishlistEvent();
  const {
    handleRemoveFromWishlistEvent
  } = useRemoveFromWishlistEvent();
  const {
    trackAddToWishlistEvent
  } = useTrackAddToWishlist();
  const {
    trackRemoveFromWishlistEvent
  } = useTrackRemoveFromWishlist();
  const {
    showSnackbar
  } = useSnackbarHandler();
  const isWishlistItem = useMemo(() => items?.some(item => item?.id === productId), [items, productId]);
  const handleWishlistToggle = useCallback(async () => {
    if (!isWishlistItem) {
      startTransition(async () => {
        const response = await addToWishlist(productId, locale);
        showSnackbar(response);
        if (response?.success) {
          handleAddToWishlistEvent(product);
          trackAddToWishlistEvent(product);
        }
      });
    } else {
      startTransition(async () => {
        const response = await removeFromWishlist(productId, locale);
        showSnackbar(response);
        if (response?.success) {
          handleRemoveFromWishlistEvent(product);
          trackRemoveFromWishlistEvent(product);
        }
      });
    }
  }, [isWishlistItem, productId, product, handleAddToWishlistEvent, handleRemoveFromWishlistEvent, trackRemoveFromWishlistEvent, trackAddToWishlistEvent, locale, showSnackbar]);
  return <span className={cx("border-supportiveGray absolute top-3 z-40 ms-auto flex justify-center rounded-full border bg-white p-1", {
    "h-9 w-9 md:h-11 md:w-11": variant === "md",
    "h-6 w-6 md:h-9 md:w-9": variant === "sm",
    "end-7 md:end-3": isPdp,
    "end-3": !isPdp
  })} data-sentry-component="ToggleWishlistButton" data-sentry-source-file="ToggleWishlistButton.jsx">
      <button onClick={() => handleWishlistToggle(productId)} className="flex items-center" aria-label="Add to wishlist">
        {isPending ? <span className="mx-auto flex items-center justify-center">
            <LoadingDots className="bg-black" containerClass="mx-auto" />
          </span> : <span>
            {isWishlistItem ? <IconWishlistFilled className={cx("", {
          "h-[14px] w-[14px] md:h-5 md:w-5": variant === "sm",
          "h-5 w-5 md:h-5 md:w-5": variant === "md"
        })} /> : <IconWishlist className={cx("text-supportiveGray fill-current", {
          "h-[14px] w-[14px] md:h-5 md:w-5": variant === "sm",
          "h-5 w-5 md:h-5 md:w-5": variant === "md"
        })} />}
          </span>}
      </button>
    </span>;
};
export default ToggleWishlistButton;